import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { SilentRefreshService } from '@app/services/silentRefresh/silent-refresh';
import { Navbar } from '../shared/navbar/navbar';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, Navbar],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.css',
})
export class AuthLayout {
  private readonly silentRefresh = inject(SilentRefreshService);
  private readonly router = inject(Router);
  ngOnInit() {
    this.silentRefresh.start({
      app_id: environment.appId,
      intervalMs: 1000 * 60,
      origin: new URL(environment.ssoUrl).origin,
      onSuccess: (data: any) => {
        console.log('Silent refresh token success:', data);
      },
      onFailure: (error: any) => {
        this.router.navigate(['/login'], {
          queryParams: { reason: 'unauthenticated' },
        });
        console.error('Silent refresh token error:', error);
      },
    });
  }
}
